export default __webpack_public_path__ + "static/media/bracelet2.90681810.png";